<template>
  <div class="classification clearfix draggable-group select-none" ref="container">
    <div class="option-wrap">
      <div class="classification-box">
        <div class="classification-title">
          <span>选项区</span>
        </div>
        <draggable :disabled="view" v-model="issue.rows" :group="question.id" ghost-class="ghost" chosen-class="chosen">
          <transition-group tag="ul">
            <li v-for="item in issue.rows" :key="item.row_id" class="classification-item">
              <div>
                <div v-html="item.content.richText"></div>
              </div>
            </li>
          </transition-group>
        </draggable>
      </div>
    </div>
    <div class="category-wrap">
      <div class="classification-box">
        <div class="classification-title">
          <span>分类区</span>
        </div>
        <ul>
          <li v-for="item in issue.items" :key="item.id" class="category-box relative mb-2 last:mb-0">
            <div class="category-title">
              <div v-html="item.content.richText"></div>
            </div>
            <div class="relative">
              <draggable :disabled="view" v-model="item.selects" :group="question.id" ghost-class="ghost" chosen-class="chosen" class="px-2">
                <transition-group tag="div" class="category-content">
                  <div v-for="opt in item.selects" :key="opt.row_id" class="classification-item">
                    <div>
                      <div v-html="opt.content.richText"></div>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <div v-if="!item.selects.length" class="category-empty" key="category-empty">
                <span>拖入此处</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { previewImage } from '@/assets/js/preview-image'

export default {
  name: 'Classification',
  changeExpr: 'changeExpr',
  components: { draggable },
  data() {
    return {}
  },
  computed: {
    changeExpr() {
      let items = this.issue.items
      return items
        .map(item => {
          return item.selects.map(i => i.row_id).join(',')
        })
        .join('-')
    }
  },
  created() {},
  methods: {},
  watch: {
    changeExpr() {
      this.$nextTick(() => {
        if (this.$refs.container) {
          previewImage(this.$refs.container)
        }
      })
    }
  }
}
</script>
